import axios from 'axios';

const VERIFY_URL = "https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/verify";
const REFRESH_URL = "https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/refresh";

/** CRA only auto-loads `.env` from the project root, not `src/.env` — fall back so verify/refresh always send a key. */
const DEFAULT_API_KEY = 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB';

const requestConfig = {
    headers: {
        'x-api-key': process.env.REACT_APP_AWS_API_GATEWAY_KEY || DEFAULT_API_KEY,
    },
};

export function getUser() {
    const user = localStorage.getItem('user') || sessionStorage.getItem('user');
    if (user === 'undefined' || !user) {
        return null;
    }
    try {
        return JSON.parse(user);
    } catch {
        return null;
    }
}

export function getAccessToken() {
    return localStorage.getItem('accessToken') || sessionStorage.getItem('token');
}

// Backward-compatible alias used across older modules.
export function getToken() {
    return getAccessToken();
}

export function getRefreshToken() {
    return localStorage.getItem('refreshToken');
}

export function setUserSession(user, accessToken, refreshToken) {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('accessToken', accessToken);
    if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
    } else {
        localStorage.removeItem('refreshToken');
    }
}

export function resetUserSession() {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
}

// Returns the new access token on success, null on failure.
async function tryRefreshAccessToken() {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return null;

    try {
        const response = await axios.post(REFRESH_URL, { refreshToken }, requestConfig);
        const { accessToken, refreshToken: newRefreshToken } = response.data;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', newRefreshToken);

        return accessToken;
    } catch (error) {
        return null;
    }
}

export async function isUserLoggedIn() {
    try {
        const token = getAccessToken();
        const user = getUser();

        console.log('token', token);
        console.log('user', user);

        if (!token || !user) return false;

        console.log('made it here');

        const requestBody = { user, token };

        try {
            const response = await axios.post(VERIFY_URL, requestBody, requestConfig);
            return response.status === 200;
        } catch (error) {
            // Access token expired or invalid — try refreshing once (only if we have a refresh token).
            console.log('error: ', error);
            if (error.response?.status === 401) {
                const refreshToken = getRefreshToken();
                if (!refreshToken) {
                    // Cannot rotate session; do not wipe storage (avoids "instant logout" when login did not persist refresh).
                    return false;
                }
                const newToken = await tryRefreshAccessToken();
                if (!newToken) {
                    resetUserSession();
                    return false;
                }

                const retryBody = { user, token: newToken };
                const retryResponse = await axios.post(VERIFY_URL, retryBody, requestConfig);
                return retryResponse.status === 200;
            }
            throw error;
        }
    } catch (error) {
        console.error('Login verification failed:', error);
        return false;
    }
}
    